import Container from "@/components/base/Container";
import NewsletterForm from "@/components/feature/NewsletterForm";
import { siteInfo } from "@/mocks/site";

export default function SubscribeSection() {
  return (
    <section id="subscribe" className="bg-primary-950 py-16 md:py-20">
      <Container>
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-16">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.22em] text-accent-300">
              <span className="h-px w-6 bg-accent-400" />
              SUBSCRIBE
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-background-50 md:text-[2rem]">
              订阅咖位观察局，第一时间收到新解读
            </h2>
            <p className="mt-4 max-w-lg text-sm leading-relaxed text-background-200/85">
              每周三篇深度解读、每月一期热度走势，直接发到你的邮箱。也欢迎把你好奇的对比选题告诉我们，我们会优先安排。
            </p>
            <ul className="mt-6 space-y-3 text-sm text-background-100/90">
              <li className="flex items-center gap-3">
                <span className="flex h-5 w-5 items-center justify-center text-accent-400">
                  <i className="ri-checkbox-circle-line text-lg" />
                </span>
                不推送广告，只发内容本身
              </li>
              <li className="flex items-center gap-3">
                <span className="flex h-5 w-5 items-center justify-center text-accent-400">
                  <i className="ri-checkbox-circle-line text-lg" />
                </span>
                随时可退订，邮箱不外借
              </li>
              <li className="flex items-center gap-3">
                <span className="flex h-5 w-5 items-center justify-center text-accent-400">
                  <i className="ri-checkbox-circle-line text-lg" />
                </span>
                商务与选题合作：{siteInfo.mediaEmail}
              </li>
            </ul>
          </div>

          <div className="rounded-lg border border-background-50/15 bg-background-50/5 p-6 md:p-8">
            <NewsletterForm tone="light" />
          </div>
        </div>
      </Container>
    </section>
  );
}